<template>
	<div>
		<div
			class="vccl-mainheader d-flex justify-content-between align-items-center dark-mode"
		>
			<div class="d-flex align-items-center">
				<div>
					<img
						src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
						alt=""
					/>
				</div>
				<div class="ml-3">
					<img src="../../assets/Images/vccl.svg" alt="" />
				</div>
			</div>

			<div class="d-flex align-items-center">
				<div class="recordtxt" v-if="isRecording">
					<img
						style="margin-bottom: 2px"
						src="../../assets/Images/meetingroom/record.svg"
						class="mr-2"
						alt=""
					/>
					{{ formattedTime }}
				</div>
				<div class="ml-5">
					<img
						v-if="isChatOpen"
						src="../../assets/Images/meetingroom/messages-active.svg"
						alt=""
						@click="toggleChat"
					/>
					<img
						v-else-if="unreadMessage"
						src="../../assets/Images/meetingroom/messages-notif.svg"
						alt=""
						@click="toggleChat"
					/>
					<img
						v-else
						src="../../assets/Images/meetingroom/messages.svg"
						alt=""
						@click="toggleChat"
					/>
				</div>
				<div class="ml-4">
					<img
						v-if="isDetailsOpen"
						src="../../assets/Images/meetingroom/people-active.svg"
						alt=""
						@click="toggleDetails"
					/>
					<img
						v-else
						src="../../assets/Images/meetingroom/people.svg"
						alt=""
						@click="toggleDetails"
					/>
				</div>
				<div class="ml-4 mr-3 position-relative">
					<img
						v-if="!showMore"
						src="../../assets/Images/meetingroom/more.svg"
						alt=""
						@click="toggleMore"
					/>
					<img
						v-else
						src="../../assets/Images/meetingroom/more-active.svg"
						alt=""
						@click="toggleMore"
					/>

					<div class="profile-dd" v-if="showMore">
						<div class="profile-dd-options-selected">
							<div class="profile-dd-txt">Start Recording</div>
						</div>
						<div class="profile-dd-options">
							<div class="profile-dd-txt">Settings</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventBus from "@/utils/EventBus";
export default {
	data() {
		return {
			elapsedSeconds: 0,
			timerInterval: null,

			isChatOpen: false,
			isDetailsOpen: false,

			showMore: false,
			unreadMessage: false,

			isRecording: false,
		};
	},
	methods: {
		toggleMore() {
			this.showMore = !this.showMore;
		},
		toggleChat() {
			if (this.isChatOpen) {
				this.unreadMessage = false;
			}
			this.isChatOpen = !this.isChatOpen;
			this.isDetailsOpen = false;
			EventBus.$emit("toggle-chat");
		},
		toggleDetails() {
			this.isDetailsOpen = !this.isDetailsOpen;
			this.isChatOpen = false;
			EventBus.$emit("toggle-details");
		},
	},
	computed: {
		formattedTime() {
			const minutes = Math.floor(this.elapsedSeconds / 60);
			const seconds = this.elapsedSeconds % 60;

			const pad = (value) => (value < 10 ? `0${value}` : value);

			return `${pad(minutes)}:${pad(seconds)}`;
		},
	},
	created() {
		this.timerInterval = setInterval(() => {
			this.elapsedSeconds += 1;
		}, 1000); // Update the timer every 1000 milliseconds (1 second)

		EventBus.$on("close-chat", () => {
			this.isChatOpen = false;
			this.unreadMessage = false;
		});

		EventBus.$on("close-details", () => {
			this.isDetailsOpen = false;
		});

		EventBus.$on("unread-message", () => {
			this.unreadMessage = true;
		});
	},
};
</script>

<style></style>
